// Code generated by Slice Machine. DO NOT EDIT.

import dynamic from "next/dynamic";

export const components = {
  address_checker: dynamic(() => import("./AddressChecker")),
  alert_banner: dynamic(() => import("./AlertBanner")),
  banner: dynamic(() => import("./Banner")),
  banner_slider: dynamic(() => import("./BannerSlider")),
  body_copy: dynamic(() => import("./BodyCopy")),
  campaign: dynamic(() => import("./Campaign")),
  choose_a_provider: dynamic(() => import("./ChooseAProvider")),
  choose_a_provider_intro: dynamic(() => import("./ChooseAProviderIntro")),
  contact_form: dynamic(() => import("./ContactForm")),
  downloads_list: dynamic(() => import("./DownloadsList")),
  faq: dynamic(() => import("./Faq")),
  feature_panelsx3: dynamic(() => import("./FeaturePanelsx3")),
  footer_links: dynamic(() => import("./FooterLinks")),
  forms_embed_code: dynamic(() => import("./FormsEmbedCode")),
  full_width_image: dynamic(() => import("./FullWidthImage")),
  glossary: dynamic(() => import("./Glossary")),
  help: dynamic(() => import("./Help")),
  home_page_address_checker_panel: dynamic(
    () => import("./HomePageAddressCheckerPanel"),
  ),
  icon_grid: dynamic(() => import("./IconGrid")),
  icon_panels: dynamic(() => import("./IconPanels")),
  large_image: dynamic(() => import("./LargeImage")),
  line_separator: dynamic(() => import("./LineSeparator")),
  link_buttons: dynamic(() => import("./LinkButtons")),
  marketing_category_items: dynamic(() => import("./MarketingCategoryItems")),
  marketing_roadmap: dynamic(() => import("./MarketingRoadMap")),
  mega_nav: dynamic(() => import("./MegaNav")),
  need_to_talk: dynamic(() => import("./NeedToTalk")),
  network_status: dynamic(() => import("./NetworkStatus")),
  news_filter_and_listing: dynamic(() => import("./NewsFilterAndListing")),
  news_hero_feature: dynamic(() => import("./NewsHeroFeature")),
  numbered_panels: dynamic(() => import("./NumberedPanels")),
  partners: dynamic(() => import("./Partners")),
  people_grid: dynamic(() => import("./PeopleGrid")),
  popup_modal: dynamic(() => import("./PopupModal")),
  project_roadmap: dynamic(() => import("./ProjectRoadMap")),
  related_content: dynamic(() => import("./RelatedContent")),
  roadmap_category_items: dynamic(() => import("./RoadmapCategoryItems")),
  rsp_informer_list: dynamic(() => import("./RspInformerList")),
  search: dynamic(() => import("./Search")),
  share_bar: dynamic(() => import("./ShareBar")),
  six_column_table: dynamic(() => import("./SixColumnTable")),
  socials: dynamic(() => import("./Socials")),
  speed_checker: dynamic(() => import("./SpeedChecker")),
  tabbed_number_panels: dynamic(() => import("./TabbedNumberPanels")),
  team: dynamic(() => import("./Team")),
  testimonials_slider: dynamic(() => import("./TestimonialsSlider")),
  text_columns: dynamic(() => import("./TextColumns")),
  text_panel: dynamic(() => import("./TextPanel")),
  text_panels: dynamic(() => import("./TextPanels")),
  two_column_images: dynamic(() => import("./TwoColumnImages")),
  two_columns: dynamic(() => import("./TwoColumns")),
  video_panels: dynamic(() => import("./VideoPanels")),
  video_with_intro: dynamic(() => import("./VideoWithIntro")),
};
